import { Box } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Paragraph } from '@treams/treams-ui';

import EvaluationSubmissionGraph from '../../../../conversations/evaluation-submission/EvaluationSubmissionGraph';

export default function FinalScore(props: {
	name: string;
	item: graphql.EvaluationFinalScoreItem;
	score?: number;
	readonly?: boolean;
}) {
	const { localize } = useLocalize();

	const exampleScores = [0.1, 0.4, 0.9, 0.3, 0.7];

	return (
		<>
			<Box maxWidth={600}>
				<Paragraph>{localize(props.item.title ?? [])?.text ?? 'Summary'}</Paragraph>
			</Box>
			<EvaluationSubmissionGraph
				levels={(props.item.displayLevelSet ?? props.item.competencyLevelSet)!.levels.map(
					(level) => localize(level.title).text,
				)}
				sections={exampleScores.map((score, index) => ({
					name: `§ ${index + 1}`,
					score,
				}))}
			/>
		</>
	);
}
